import React from 'react'
import Banner_1 from '../../../assets/images/home_page_6/banner/01.png'
import Banner_2 from '../../../assets/images/home_page_6/banner/02.png'
import Banner_3 from '../../../assets/images/home_page_6/banner/03.png'
import Banner_4 from '../../../assets/images/home_page_6/banner/04.png'

const Banner = () => {
    return (
        <>
            <section id="home-six" className="home-six-main-block">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="home-six-banner-dtl">
                                <h6 className="home-six-sub-title">
                                    Exclusive Offer{" "}
                                    <span className="badge text-bg-primary">-20%Off</span>
                                </h6>
                                <h2 className="home-six-title">Achieve Digital Brilliance</h2>
                                <p>We have prepared special discounts for you on electronic</p>
                                <form>
                                    <div className="form-group">
                                        <select
                                            className="form-select"
                                            aria-label="Default select example"
                                        >
                                            <option selected="">Categories</option>
                                            <option value={1}>Fashion</option>
                                            <option value={2}>Accessories</option>
                                            <option value={3}>Electronics</option>
                                        </select>
                                        <div className="form-group-input">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="search"
                                                placeholder="Search your products...."
                                            />
                                            <button type="button" className="btn btn-primary-six">
                                                Search <i className="flaticon-right-arrow" />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="home-six-bg-img-block">
                                <div className="home-six-gradient-img text-center">
                                    <img
                                        src={Banner_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="home-six-bg-img">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="home-six-img text-center">
                                                <img
                                                    src={Banner_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="home-six-img">
                                                <img
                                                    src={Banner_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="home-six-img">
                                                <img
                                                    src={Banner_4}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="home-six-circle-one" />
                <div className="home-six-circle-two" />
            </section>

        </>
    )
}

export default Banner
